import React, {Component} from 'react';
import {connect} from 'react-redux';

import {Button, Header, Icon, Label, Loader, Message, Popup, Segment, Table} from 'semantic-ui-react';

import {getApplication, getApplicationPayments} from "../../actions/application";

class ApplicationPayments extends Component {

    componentDidMount() {
        if (!this.props.authenticated) {
            this.props.history.push("/logowanie")
        } else {
            if (typeof this.props.application.id === "undefined" || this.props.match.params.applicationId !== this.props.application.id) {
                this.props.dispatch(getApplication(this.props.match.params.applicationId));
            }
            this.props.dispatch(getApplicationPayments(this.props.match.params.applicationId));
        }
    }

    componentDidUpdate() {
        if (!this.props.authenticated) {
            this.props.history.push("/logowanie")
        }
    }

    onClickRefresh(e) {
        this.props.dispatch(getApplicationPayments(this.props.match.params.applicationId));
    }

    onClickBack(e) {
        this.props.history.push("/zgloszenia/" + this.props.match.params.applicationId);
    }

    render() {
        return (
            <div style={{margin: "1rem 0"}}>
                {this.renderLoader()}
                {this.renderLoadingError()}
                {this.renderPayments()}
            </div>
        );
    }

    renderLoader() {
        return (this.props.loadingApplication || this.props.loadingPayments) &&
            <Segment textAlign='center' padded='very'><Loader inline active
                                                              content='Wczytywanie listy opłat'/></Segment>
    }

    renderLoadingError() {
        return !this.props.loadingApplication
            && !this.props.loadingPayments
            && (this.props.loadingPaymentsFailed || this.props.loadingApplicationFailed)
            && <Message negative
                        icon='exclamation triangle'
                        header='Nie udało sie pobrać listy opłat'
                        content={this.props.loadingPaymentsError + ' ' + this.props.loadingApplicationError}/>
    }

    renderPayments() {
        return !this.props.loadingApplication
            && !this.props.loadingPayments
            && !this.props.loadingApplicationFailed
            && !this.props.loadingPaymentsFailed
            && [this.renderHeader(), this.renderBody()]
    }

    renderHeader() {
        return <Table key={1} attached="top" className="application-header">
            <Table.Header>
                <Table.Row>
                    <Table.HeaderCell colSpan={2}>
                        <Header>
                            <Icon name="trophy"/>
                            <Header.Content>{this.props.contest.name}
                                <Header.Subheader>
                                    {this.props.application.status === 'DRAFT' && 'Zgłoszenie w przygotowaniu'}
                                    {this.props.application.status === 'SENT' && 'Zgłoszenie wysłane'}
                                    {this.props.application.status === 'REJECTED' && 'Zgłoszenie odrzucone'}
                                    {this.props.application.status === 'APPROVED' && 'Zgłoszenie zaakceptowane'}
                                </Header.Subheader>
                            </Header.Content>
                        </Header>
                    </Table.HeaderCell>
                </Table.Row>
            </Table.Header>
            <Table.Body>
                <Table.Row>
                    <Table.Cell>
                        <Popup trigger={<Label size='large'><Icon
                            name='folder open outline'/> {this.props.application.categoryCount}
                        </Label>}
                               content="Ilość kategorii z przynajmniej jedną prezentacją"
                               position="bottom left"
                               inverted/>
                        <Popup
                            trigger={<Label size='large'><Icon name='image'/> {this.props.application.presentationCount}
                            </Label>}
                            content="Ilość prezentacji"
                            position="bottom left"
                            inverted/>
                        <Popup
                            trigger={<Label size='large'><Icon name='users'/> {this.props.application.participantCount}
                            </Label>}
                            content="Ilość zgłoszonych zawodników"
                            position="bottom left"
                            inverted/>
                        <Popup trigger={<Label size='large'><Icon
                            name='money bill alternate outline'/> {this.props.application.totalCost}
                        </Label>}
                               content="Całkowity koszt zgłoszenia"
                               position="bottom left"
                               inverted/>
                    </Table.Cell>
                    <Table.Cell collapsing textAlign="right">
                        <Popup trigger={<Button icon="arrow left"
                                                onClick={(e) => this.onClickBack(e)}/>}
                               content="Wróć do zgłoszenia"
                               position="bottom left"
                               inverted/>
                        <Popup trigger={<Button secondary
                                                icon="refresh"
                                                onClick={(e) => this.onClickRefresh(e)}/>}
                               content="Odśwież"
                               position="bottom right"
                               inverted/>
                    </Table.Cell>
                </Table.Row>
            </Table.Body>
        </Table>
    }

    renderBody() {
        return <Table key={2} attached="bottom">
            <Table.Header>
                <Table.Row>
                    <Table.HeaderCell width={8}>Zawodnik / Kategoria</Table.HeaderCell>
                    <Table.HeaderCell width={4} textAlign="right">Ilość prezentacji</Table.HeaderCell>
                    <Table.HeaderCell width={4} textAlign="right">Koszt uczestnictwa</Table.HeaderCell>
                </Table.Row>
            </Table.Header>
            <Table.Body>
                {this.props.payments.length === 0 && <Table.Row>
                    <Table.Cell colSpan={3} textAlign="center">Lista jest pusta</Table.Cell>
                </Table.Row>}
                {this.props.payments.map((payment, index) => <Table.Row key={index}>
                    <Table.Cell>{payment.name}</Table.Cell>
                    <Table.Cell textAlign="right">{payment.presentationCount}</Table.Cell>
                    <Table.Cell textAlign="right">{payment.amount}</Table.Cell>
                </Table.Row>)}
            </Table.Body>
        </Table>
    }
}

function mapStateToProps(state) {
    return {
        authenticated: state.session.authenticated,
        loadingApplication: state.application.loadingApplication,
        loadingApplicationFailed: state.application.loadingApplicationFailed,
        loadingApplicationError: state.application.loadingApplicationError,
        application: state.application.application,
        contest: state.application.contest,
        categories: state.application.categories,
        participants: state.application.participants,
        loadingPayments: state.application.loadingPayments,
        loadingPaymentsFailed: state.application.loadingPaymentsFailed,
        loadingPaymentsError: state.application.loadingPaymentsError,
        payments: state.application.payments
    }
}

export default connect(mapStateToProps)(ApplicationPayments)


// WEBPACK FOOTER //
// ./src/components/routes/ApplicationPayments.js